module.exports = __webpack_public_path__ + "static/img/001.e755015.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/intellectual_property/001.png
// module id = oZaB
// module chunks = 0